import request from './api'

// 查询科目
export const FindSubject = (params, opts) =>
    request(`/api-resource/cjdd-resources/resourses/get/material/catalog?professionId=${params}`, opts);

// 查询试卷list
export const SelectTestPaPer = (params, opts) =>
    request('/api-resource/testPaper/selectTestPaPer', params, {
        ...opts,
        method: 'post'
    });

// 根据科目查询标签
export const FindLabel = (params, opts) =>
    request('/api-resource/question/findLabel', params, opts);   // params {id: ''}

// 删除试卷
export const DeleteTestPaper = (params, opts) =>
    request('/api-resource/testPaper/deleteTestPaper', params, opts);   // params {id: ''}

// 根据试卷id查询试卷详情
export const SelectById = (params, opts) =>
    request('/api-resource/testPaper/selectById', params, opts);   // params {id: ''}
// 根据试卷id查询试卷选做已选题数
export const GetQuestionSelected = (params, opts) =>
    request(`/api-resource/testPaper/getQuestionSelected/${params}`, opts);   // params {id: ''}// 根据试卷id查询试卷选做已选题数
// 根据试卷id查询分值
export const GetScoreStatistics = (params, opts) =>
    request(`/api-resource/testPaperBasicInformation/scoreStatistics/${params}`, opts);
// 根据试卷id查询关联公司
export const GetFindCaseCompany = (params, opts) =>
    request(`/api-resource/testPaperBasicInformation/findCaseCompany/${params}`, opts);
// 根据试卷id查询业务系统
export const GetFindBusinessSystem = (params, opts) =>
    request(`/api-resource/testPaperBasicInformation/testPaperBusinessSystem/${params}`, opts);
// 根据试卷id查询机器和人工评分
export const GetFindJobScore = (params, opts) =>
    request(`/api-resource/testPaperBasicInformation/jobScoreStatistics/${params}`, opts);
// 根据试卷id清除已选题数
export const DeleteQuestionSelected = (params, opts) =>
    request(`/api-resource/testPaper/deleteQuestionSelected/${params}`, opts);   // params {id: ''}

// 保存试卷
export const AddTestPaper = (params, opts) =>
    request('/api-resource/testPaper/addTestPaper', params, {
        ...opts,
        method: 'post'
    });

// 推送试卷
export const ExportPapers = (params, opts) =>
    request('/api-resource/testPaper/exportPapers', params, {
        ...opts,
        method: 'post'
    });

// 发布试卷
export const PublicPaper = (params, opts) =>
    request('/api-resource/testPaper/publicPaper', params, {
        ...opts,
        method: 'post'
    });

// 编辑前判断是否已作答
export const JudgePaper = (params, opts) =>
    request(`/api-study/paper/is/exist/record/${params}`, opts);   // params {id: ''}

// 根据科目查询题型
export const FindTypeBySubject = (params, opts) =>
    request('/api-resource/questionType/select', params, opts);   // params {id: ''}

// 实操题设置前置题目
export const FindStationNameByQuestionId = (params, opts) =>
    request('/api-resource/question/find/stationNameByQuestionId', params, opts);   // params {id: ''}

// 实操题设置前置题目 - 保存
export const SetPreTaskName = (params, opts) =>
    request('/api-resource/testPaper/set/preTaskName', params, {
        ...opts,
        method: 'post'
    });


// 根据资源ID 获取动态参数列表
export const GetParamsById = (params, opts) =>
    request(`/api-resource/dynmaicParam/get/dynmaic/param/${params}`, opts);   // params {id: ''}
export const QueryDetailByQuestionId = (params, opts) =>
    request(`/api-resource/taskEventres/queryDetailByQuestionId/${params}`, opts);   // params {id: ''}
export const EventTemplateById = (params, opts) =>
    request(`/api-resource/repeat/eventTemplate/?ids=${params}`, opts);   // params {id: ''}
export const GetDynmaicParamList = (params) =>
    request(`/api-resource/dynmaicParam/get/dynmaic/param/list/${params}`);   // params {id: ''}

    // 复制试卷
export const CopyPaper = (params, opts) =>
    request('/api-resource/testPaper/copy', params, { ...opts, method: 'post' });

/**
 * 试卷加密
 *  */
// 加密
export const PaperEncryption = (params, opts) =>
    request('/api-resource/testPaper/paperEncryption', params, { ...opts, method: 'post' });
// 试卷解密（编辑试题、预览、编辑）
export const EditPaperDecryption = (params, opts) =>
    request('/api-resource/testPaper/editPaperDecryption', params, { ...opts, method: 'post' });
// 试题解密
export const QuestionDecryption = (params, opts) =>
    request('/api-resource/testPaper/questionDecryption', params, { ...opts, method: 'post' });
// 取消加密
export const CancelPaperEncryption = (params, opts) =>
    request('/api-resource/testPaper/cancelPaperEncryption', params, { ...opts, method: 'post' });
// 操作记录
export const FindOperationRecordByPaperId = (params, opts) =>
request('/api-resource/testPaper/findOperationRecordByPaperId', params, { ...opts, method: 'get' });
// 增加试卷操作记录
export const AddPaperOperationRecord = (params, opts) =>
    request('/api-resource/testPaper/addPaperOperationRecord', params, { ...opts, method: 'post' });
// 增加试题操作记录
export const AddQuestionOperationRecord = (params, opts) =>
    request('/api-resource/question/addQuestionOperationRecord', params, { ...opts, method: 'post' });
// 增加科目操作记录
export const AddSubjectOperationRecord = (params, opts) =>
    request('/api-resource/cjdd-resources/addSubjectOperationRecord', params, { ...opts, method: 'post' });
// 根据试卷id,课程id 查询试卷 资源分类
export const QueryByCourseIdAndResourceId = (params, opts) =>
  request('/api-course/catalog/queryByCourseIdAndResourceId', params, opts);



// WEBPACK FOOTER //
// ./src/api/testPaperApi.js